/**
 * Footer accordion — toggles link-list sub-menus on mobile.
 * Loaded with defer from sections/footer.liquid.
 */
document.querySelectorAll('.footer_accordion').forEach((accordion) => {
  accordion.addEventListener('click', () => {
    accordion.classList.toggle('opened');
    const content = accordion.nextElementSibling;

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
});
